(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["figgi-vip-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storage = {
      get(key) {
        try {
          return window.localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      },

      set(key, value) {
        try {
          window.localStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      },

      remove(key) {
        try {
          window.localStorage.removeItem(key);
        } catch (error) {
          return;
        }
      }
    };

    const initPopup = (popup) => {
      if (popup.dataset.initialized === 'true') return;

      popup.dataset.initialized = 'true';

      const joinedKey = 'figgiVipJoined';
      const dismissedKey = 'figgiVipDismissedUntil';
      const isDesignMode = Boolean(
        window.Shopify && window.Shopify.designMode
      );
      const isSuccess = popup.dataset.success === 'true';
      const hasErrors = popup.dataset.errors === 'true';
      const customerSubscribed =
        popup.dataset.customerSubscribed === 'true';
      const delay = Number(popup.dataset.delay) || 6000;
      const dismissDays = Number(popup.dataset.dismissDays) || 14;

      let completed = isSuccess;

      const openPopup = () => {
        if (!popup.open) popup.showModal();
      };

      const closePopup = () => {
        if (popup.open) popup.close();
      };

      if (isSuccess) {
        storage.set(joinedKey, 'true');
        storage.remove(dismissedKey);
        openPopup();
      } else if (hasErrors || isDesignMode) {
        openPopup();
      } else {
        const joined =
          storage.get(joinedKey) === 'true' || customerSubscribed;
        const dismissedUntil = Number(
          storage.get(dismissedKey) || 0
        );

        if (!joined && Date.now() > dismissedUntil) {
          window.setTimeout(openPopup, delay);
        }
      }

      popup
        .querySelectorAll('[data-figgi-vip-close]')
        .forEach((button) => {
          button.addEventListener('click', closePopup);
        });

      popup.addEventListener('click', (event) => {
        if (event.target === popup) closePopup();
      });

      popup.addEventListener('close', () => {
        if (!completed && !isDesignMode) {
          const until =
            Date.now() +
            dismissDays * 24 * 60 * 60 * 1000;

          storage.set(dismissedKey, String(until));
        }
      });

      const form = popup.closest('form');

      if (form) {
        form.addEventListener('submit', () => {
          completed = true;
        });
      }
    };

    const initAll = (scope = document) => {
      scope
        .querySelectorAll('[data-figgi-vip-popup]')
        .forEach(initPopup);
    };

    initAll();

    document.addEventListener(
      'shopify:section:load',
      (event) => initAll(event.target)
    );

    document.addEventListener(
      'shopify:section:select',
      (event) => {
        const popup = event.target.querySelector(
          '[data-figgi-vip-popup]'
        );

        if (popup && !popup.open) {
          popup.showModal();
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
